<template>
  <v-layout justify-center align-center>
    <v-card min-width="350px" class="mt-10 rounded-xl">
      <v-card-title>
        <span class="headline"> Смена пароля </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout wrap>
            <v-flex>
              <form>
                <v-text-field
                  label="Новый пароль"
                  v-model="new_password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @input="$v.new_password.$touch()"
                  :error-messages="passwordErrors"
                  @blur="$v.new_password.$touch()"
                  @click:append="show = !show"
                  required
                  autocomplete
                  :type="show ? 'text' : 'password'"
                  class=""
                ></v-text-field>
              </form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn
          color="green lighten-1"
          class=""
          fab
          text
          :disabled="this.$v.$invalid"
          :loading="loading"
          :disable="loading"
          @click="postData"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>


<script>
// import openapi from "../config/openapi";
import axios from 'axios'
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  mixins: [validationMixin],

  validations: {
    new_password: {
      required,
      minLength: minLength(8),
      containsUppercase: function (value) {
        return /[A-Z]/.test(value);
      },
      containsLowercase: function (value) {
        return /[a-z]/.test(value);
      },
      containsNumber: function (value) {
        return /[0-9]/.test(value);
      },
    },
  },
  data: () => ({
    // url: "http://127.0.0.1:8000/api/signup/",
    baseURL: process.env.VUE_APP_API_URL,
    url: "/auth/users/reset_password_confirm/",
    new_password: "",
    show: false,
    loading: false,
  }),

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.new_password.$dirty) return errors;
      !this.$v.new_password.minLength &&
        errors.push("Пароль должен быть не меньше 8 символов");
      !this.$v.new_password.required &&
        errors.push("Пароль - обязательное поле");
      !this.$v.new_password.containsLowercase &&
        errors.push("Пароль должен содержать хотя бы одну маленькую букву");
      !this.$v.new_password.containsUppercase &&
        errors.push("Пароль должен содержать хотя бы одну заглавную букву");
      !this.$v.new_password.containsNumber &&
        errors.push("Пароль должен содержать хотя бы одну цифру");
      // console.log(errors);
      return errors;
    },
  },
  methods: {
    postData: function () {
      let uid = this.$route.params.uid;
      let token = this.$route.params.token;
      // console.log("token:" + token);
      // console.log("uid:" + uid);
      // console.log("new_password:" + this.new_password);
      const data = {
        uid: uid,
        token: token,
        new_password: this.new_password,
      }
      const url = this.baseURL + this.url
      axios
        .post(url, data)
        .then((response) => {
          response;
          // console.log(response.data);
          this.$router.push({ name: "after_password_reset" });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  beforeMount() {
    // this.postData(uid, token);
  },
};
</script>